import { render, staticRenderFns } from "./RepeatServiceSearchBox.vue?vue&type=template&id=28f5340a&scoped=true&"
import script from "./RepeatServiceSearchBox.vue?vue&type=script&lang=js&"
export * from "./RepeatServiceSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./RepeatServiceSearchBox.vue?vue&type=style&index=0&id=28f5340a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5340a",
  null
  
)

export default component.exports